<template>
  <div class="roomsList">
    <b-container class="bv-example-row mt-3">
      <b-row>
        <b-col md="2" lg="3"></b-col>
        <b-col md="8" lg="6">
          <unicon @click="updateRoomList()" :class="['refreshRoomList',roomListLoading?'spin':'']" name="sync" />
          <b-list-group v-if="roomsList.length">
            <b-list-group-item v-for="room in roomsList" :key="room.roomId">
              <label class="mt-1 float-left">{{ room.metadata.alias }}</label>
              <b-badge class="roomClientsCount" variant="primary" pill
                >{{ room.clients }}/{{ room.maxClients }}</b-badge
              >
              <b-button
                @click="joinRoom(room.roomId)"
                class="float-right"
                variant="success"
                align-h="end"
                pill
                >Join</b-button
              >
            </b-list-group-item>
          </b-list-group>
          <b-alert v-else show>No available rooms !</b-alert>
        </b-col>
        <b-col md="2" lg="3"></b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import store from "@/store";
import Server from "@/server";

export default {
  computed: {
    roomsList: () => store.state.room.roomsList,
    roomListLoading: () => store.state.roomListLoading
  },
  methods: {
    joinRoom(roomId) {
      Server.joinBingoRoom(roomId);
    },
    updateRoomList(){
      Server.updateRoomList();
    }
  }
};
</script>
